import { render, staticRenderFns } from "./AppSelect.vue?vue&type=template&id=65940da6&"
import script from "./AppSelect.vue?vue&type=script&lang=ts&"
export * from "./AppSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AppSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VChip,VSelect})
